import type { Comment, Persisted } from '@tunasong/schemas'
import type { FC, ReactNode } from 'react'
import { LikeButton } from './like-button.js'
import { TaskRow } from './task-row.js'

export interface CommentContentProps {
  comment: Persisted<Comment>
  /** The comment's body */
  children: ReactNode
}

/**
 * A people Chat comment's content: its body, as a task when it is one, then Like under it (GH #3041, #2796). The feed,
 * a block's thread and the Tasks list all show comments through this, so a comment reads the same in each.
 */
export const CommentContent: FC<CommentContentProps> = ({ comment, children }) => (
  <>
    <TaskRow comment={comment}>{children}</TaskRow>
    <LikeButton comment={comment} />
  </>
)
